<template>
    <div class="auth-screen">
        <div class="auth-card">
            <img class="auth-logo" src="/logo.png" alt="Fytlix" />
            <h1 class="auth-title">{{ $t('forgotTitle') }}</h1>
            <p class="auth-subtitle">{{ $t('forgotSubtitle') }}</p>

            <div v-if="done" class="box-success">{{ $t('forgotDone') }}</div>

            <form v-if="!done" @submit.prevent="submit">
                <label class="field">
                    <span class="field-label">{{ $t('email') }}</span>
                    <input class="field-input" type="email" inputmode="email" autocomplete="username"
                           v-model.trim="email" />
                </label>
                <button class="btn btn-primary btn-block btn-lg" type="submit" :disabled="!email">
                    <i class="fa-solid fa-paper-plane"></i> {{ $t('sendResetLink') }}
                </button>
            </form>

            <div class="auth-footer">
                <router-link :to="{ name: 'login' }">
                    <i class="fa-solid fa-arrow-left"></i> {{ $t('backToLogin') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ForgotPasswordView',
    data() {
        return {
            email: '',
            done: false
        };
    },
    methods: {
        async submit() {
            await this.$api.post('password/request', { email: this.email }, { client: false });
            // Always report success so account existence is not revealed.
            this.done = true;
        }
    }
};
</script>
